import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLabel, IonLoading, IonModal, IonPage, IonTitle, IonToast, IonToolbar, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, cardOutline, cashOutline, createOutline, pricetagOutline, printOutline, qrCodeOutline, walletOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { alterarStatusProjeto, mesaGerarCupom, requestService, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import type { DescontoPayload } from '../Desconto/Desconto';
import Desconto, { converterDescontoParaValorMonetario, resolverDescontoInicial } from '../Desconto/Desconto';
import TaxaServico from '../TaxaServico/TaxaServico';
import AlterarPagamentoModal from './AlterarPagamentoModal';
import AlterarProdutosModal from './AlterarProdutosModal';
import './ComandasDetalhes.css';

function iconePagamento(tipo: string) {
  const t = (tipo || '').toLowerCase();
  if (t.includes('credito') || t.includes('crédito') || t.includes('debito') || t.includes('débito') || t.includes('cartao') || t.includes('cartão')) return cardOutline;
  if (t.includes('pix')) return qrCodeOutline;
  if (t.includes('dinheiro')) return cashOutline;
  return walletOutline;
}

const ComandasDetalhes: React.FC = () => {
  const location = useLocation<any>();
  const history = useHistory<any>();
  const [mostrarAlerta] = useIonAlert();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState('');

  // Contexto
  const { setEsconderMenu, setNomeMenu, dadosEmpresa } = useContext(MessageContext);

  // Determinar pk do pedido
  const projetoid: string = (location.state?.id || location.state?.comanda?.pk || '').replaceAll('%23', '#');

  // Dados carregados da API
  const [dadosComandas, setDadosComandas] = useState<any>(location.state?.comanda || {});
  const [listaItemProdutos, setListaItemProdutos] = useState<any[]>(location.state?.comanda?.produtos || []);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<string>('0,00');
  const [valorTotal, setValorTotal] = useState<string>('0,00');
  const [descontoSelecionado, setDescontoSelecionado] = useState<DescontoPayload | undefined>(undefined);

  // Modais
  const [showModalTaxaServico, setShowModalTaxaServico] = useState(false);
  const [showModalDesconto, setShowModalDesconto] = useState(false);
  const [showAlterarProdutos, setShowAlterarProdutos] = useState(false);
  const [showAlterarPagamento, setShowAlterarPagamento] = useState(false);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu('');
  });

  useEffect(() => {
    if (projetoid) {
      carregarComanda();
    }
  }, [projetoid]);

  useEffect(() => {
    try {
      const taxaServicoFloat = parseFloat((dadosComandas.taxaServico || '0').replace(/\./g, '').replace(',', '.')) || 0;
      const descontoFloat = parseFloat((dadosComandas.desconto || '0').replace(/\./g, '').replace(',', '.')) || 0;
      const taxaEntregaFloat = parseFloat((dadosComandas.taxaEntrega || '0').replace(/\./g, '').replace(',', '.')) || 0;
      let total = parseFloat((valorTotalProdutos || '0').replace(/\./g, '').replace(',', '.')) || 0;
      total += taxaEntregaFloat;
      total -= descontoFloat;
      total += total * (taxaServicoFloat / 100);
      setValorTotal(total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    } catch { }
  }, [valorTotalProdutos, dadosComandas.taxaServico, dadosComandas.desconto, dadosComandas.taxaEntrega]);

  useEffect(() => {
    setDescontoSelecionado((atual) => resolverDescontoInicial(dadosComandas.desconto, valorTotalProdutos, atual));
  }, [dadosComandas.desconto, valorTotalProdutos]);

  function carregarComanda() {
    const consultar = async () => {
      const token = localStorage.getItem('token') || '';
      setShowLoading(true);
      try {
        const resp = await fetch(
          urlBaseCore.url + '/ordens/' + projetoid.replaceAll(/#/g, '%23') + '/semassinar',
          { method: urlBaseCore.method, headers: [['token', token]] as any, credentials: 'include' }
        );
        const response = await resp.json();
        if (response.Item !== undefined) {
          setDadosComandas(response.Item);
          const prods = response.Item.produtos || [];
          setListaItemProdutos(prods);
          const total = prods.reduce((acc: number, item: any) => {
            return acc + (parseFloat(String(item.subtotal).replace(/\./g, '').replace(',', '.')) || 0);
          }, 0);
          setValorTotalProdutos(total.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        }
      } catch (e) {
        console.error(e);
      } finally {
        setShowLoading(false);
      }
    };
    consultar();
  }

  async function alterar(formaPagamento: any, taxaServico: any, taxaEntrega: any, desconto: any) {
    return new Promise((resolve, reject) => {
      requestService(
        alterarStatusProjeto.url.replaceAll('{id}', projetoid.replaceAll(/#/g, '%23')) + '?alteracao=true',
        {
          method: alterarStatusProjeto.method,
          headers: [['token', localStorage.getItem('token') || '']] as any,
          credentials: 'include',
          body: JSON.stringify({ formaPagamento, taxaEntrega, taxaServico, desconto }),
        },
        history,
        (response: any) => {
          setDadosComandas(response);
          setValorTotal((response.valorTotal || 0).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
          resolve(response);
        },
        (error: any) => {
          setTextToast(error.message);
          setShowToast(true);
          reject(error);
        }
      );
    });
  }

  async function imprimir() {
    return new Promise<void>((resolve, reject) => {
      const url = mesaGerarCupom.url.replace('{id}', projetoid.replaceAll(/#/g, '%23'));
      requestService(url, { method: mesaGerarCupom.method }, history,
        (data: any) => {
          mostrarAlerta({
            backdropDismiss: false, header: 'Cupom',
            message: '<strong>Cupom</strong> gerado com sucesso.',
            buttons: [
              { text: 'Cancelar', role: 'cancel' },
              { text: 'Visualizar', handler: () => { window.open(data, '_blank'); } }
            ],
          });
          resolve();
        },
        (err: any) => {
          setTextToast(err?.message || 'Erro ao gerar cupom.');
          setShowToast(true);
          reject(err);
        }
      );
    });
  }

  function dataFormatada(dateStr: string | undefined) {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleString('pt-BR');
  }

  const anotacoesFiltradas = (dadosComandas.anotacoes || [])
    .filter((a: any) => !Array.isArray(a))
    .sort((a: any, b: any) => (a.data < b.data ? 1 : -1));

  const nomeProdutoLabel = (prod: any): string => {
    if (Array.isArray(prod.descricao)) {
      if (prod.tipo === 'pizzas') return `${prod.tamanho} ${prod.quantidadeSabores} SABORES`;
      return prod.categoria || prod.descricao?.[0]?.descricao || '-';
    }
    return prod.descricao || '-';
  };

  const complementosProd = (prod: any) => {
    if (!Array.isArray(prod.descricao)) return [];
    return prod.descricao.slice(1).filter((c: any) => c.descricao);
  };

  if (!projetoid && !dadosComandas?.pk) {
    return (
      <IonPage>
        <IonHeader><IonToolbar color="primary"><IonButtons slot="start"><IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton></IonButtons><IonTitle>Detalhes</IonTitle></IonToolbar></IonHeader>
        <IonContent className="ion-padding"><p>Nenhuma informação disponível.</p></IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}><IonIcon icon={arrowBack} /></IonButton>
          </IonButtons>
          <IonTitle>
            {dadosComandas.clienteNome || window.localStorage.getItem('nomeInternoMesasOuComandas') || 'Comanda'}
          </IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={async () => { setShowLoading(true); imprimir().finally(() => setShowLoading(false)); }}>
              <IonIcon slot="icon-only" icon={printOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonLoading isOpen={showLoading} message="Aguarde..." />

        {/* Info abertura/encerramento */}
        <div className="detDates">
          <div className="detDateItem">
            <span className="detDateLabel">Abertura</span>
            <span className="detDateValue">{dataFormatada(dadosComandas.dataCadastro)}</span>
          </div>
          {dadosComandas.dataAlteracao && (
            <div className="detDateItem">
              <span className="detDateLabel">Encerramento</span>
              <span className="detDateValue">{dataFormatada(dadosComandas.dataAlteracao)}</span>
            </div>
          )}
        </div>

        {/* Produtos */}
        <div className="detSection">
          <div className="detSectionHeader">
            <p className="detSectionTitle">Produtos</p>
            <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" onClick={() => setShowAlterarProdutos(true)}>
              <IonIcon slot="icon-only" icon={createOutline} />
            </IonButton>
          </div>
          {listaItemProdutos.length === 0 && (
            <span style={{ fontSize: '13px', color: '#aaa' }}>Nenhum produto.</span>
          )}
          {listaItemProdutos.map((prod: any, pi: number) => {
            const complementos = complementosProd(prod);
            return (
              <div key={'cmdprod' + pi} className="detProdRow">
                <div className="detProdInfo">
                  <span className="detProdNome">
                    <b>{Number(prod.quantidade).toLocaleString('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}x</b> {nomeProdutoLabel(prod)}
                  </span>
                  {complementos.map((c: any, ci: number) => (
                    <span key={'comp' + pi + ci} className="detCompItem">
                      {c.categoria === 'Observação' ? `Obs: ${c.descricao}` : `+ ${c.descricao}${c.valor && c.valor !== '0,00' ? ` (R$ ${c.valor})` : ''}`}
                    </span>
                  ))}
                  {prod.anotacao && <span className="detProdObs">{prod.anotacao}</span>}
                </div>
                <div className="detProdPreco">
                  <span className="detProdUnit">unt. R$ {prod.valor}</span>
                  <span className="detProdSubtotal">R$ {prod.subtotal}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Resumo Financeiro */}
        <div className="detSection">
          <div className="detSectionHeader">
            <p className="detSectionTitle">Resumo</p>
            <div style={{ display: 'flex', gap: '2px' }}>
              <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" title="Desconto" onClick={() => setShowModalDesconto(true)}>
                <IonIcon slot="icon-only" icon={pricetagOutline} />
              </IonButton>
              <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" title="Taxa de serviço" onClick={() => setShowModalTaxaServico(true)}>
                <IonLabel style={{ fontSize: '22px', fontWeight: 'bold' }}>%</IonLabel>
              </IonButton>
            </div>
          </div>
          <div className="detResumoRow">
            <span>Subtotal produtos</span>
            <span>R$ {valorTotalProdutos}</span>
          </div>
          {dadosComandas.taxaServico && (
            <div className="detResumoRow">
              <span>Taxa de serviço ({dadosComandas.taxaServico}%)</span>
              <span>R$ {(
                (parseFloat((valorTotalProdutos || '0').replace(/\./g, '').replace(',', '.')) || 0)
                * (parseFloat((dadosComandas.taxaServico || '0').replace(/\./g, '').replace(',', '.')) || 0)
                / 100
              ).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>
          )}
          {dadosComandas.taxaEntrega && (
            <div className="detResumoRow">
              <span>Taxa de entrega</span>
              <span>R$ {dadosComandas.taxaEntrega}</span>
            </div>
          )}
          {dadosComandas.desconto && (
            <div className="detResumoRow detDesconto">
              <span>Desconto</span>
              <span>- R$ {dadosComandas.desconto}</span>
            </div>
          )}
          <div className="detTotalRow">
            <span>TOTAL</span>
            <span>R$ {valorTotal}</span>
          </div>
        </div>

        {/* Formas de Pagamento */}
        <div className="detSection">
          <div className="detSectionHeader">
            <p className="detSectionTitle">Pagamento</p>
            <IonButton fill="clear" size="small" color="primary" className="detSectionEditBtn" onClick={() => setShowAlterarPagamento(true)}>
              <IonIcon slot="icon-only" icon={createOutline} />
            </IonButton>
          </div>
          {(dadosComandas.formaPagamento?.length > 0) ? (
            <>
              {dadosComandas.formaPagamento.map((pag: any, fi: number) => (
                <div key={'cmdpag' + fi} className="detPagRow">
                  <IonIcon icon={iconePagamento(pag.tipo || pag.pagamento)} className="detPagIcon" />
                  <span className="detPagTipo">{pag.tipo || pag.pagamento}</span>
                  <span className="detPagValor">R$ {pag.valor}</span>
                </div>
              ))}
              {dadosComandas.troco && dadosComandas.troco !== '0,00' && (
                <div className="detResumoRow detTroco">
                  <span>Troco</span>
                  <span>R$ {dadosComandas.troco}</span>
                </div>
              )}
            </>
          ) : (
            <span style={{ fontSize: '13px', color: '#aaa' }}>Nenhum pagamento registrado.</span>
          )}
        </div>

        {/* Anotações */}
        {anotacoesFiltradas.length > 0 && (
          <div className="detSection">
            <p className="detSectionTitle">Anotações</p>
            {anotacoesFiltradas.map((anotacao: any) => (
              <div key={'cmdanot' + anotacao.id} className="detAnotRow">
                <span className="detAnotMeta">
                  {new Date(anotacao.data).toLocaleDateString('pt-BR')} {new Date(anotacao.data).toLocaleTimeString('pt-BR')}
                  {anotacao.pessoa && <b> · {anotacao.pessoa}</b>}
                </span>
                <span className="detAnotTexto">{anotacao.anotacao}</span>
              </div>
            ))}
          </div>
        )}

        <div style={{ height: 24 }} />

        {/* Modal: Taxa de serviço */}
        <IonModal isOpen={showModalTaxaServico} onDidDismiss={() => setShowModalTaxaServico(false)}>
          <TaxaServico
            projetoid={projetoid.replaceAll(/#/g, '%23')}
            valorInicial={dadosComandas.taxaServico}
            modalAberto={showModalTaxaServico}
            closeAction={async (taxa: any) => {
              setShowModalTaxaServico(false);
              await alterar(dadosComandas.formaPagamento, taxa, dadosComandas.taxaEntrega, dadosComandas.desconto);
              carregarComanda();
            }}
            closeActionSimple={() => setShowModalTaxaServico(false)}
          />
        </IonModal>

        {/* Modal: Desconto */}
        <IonModal isOpen={showModalDesconto} onDidDismiss={() => setShowModalDesconto(false)}>
          <Desconto
            projetoid={projetoid.replaceAll(/#/g, '%23')}
            totalBase={valorTotalProdutos}
            valorInicial={descontoSelecionado}
            modalAberto={showModalDesconto}
            closeAction={async (desc: DescontoPayload) => {
              setShowModalDesconto(false);
              setDescontoSelecionado(desc);
              const descontoMonetario = converterDescontoParaValorMonetario(desc, valorTotalProdutos);
              await alterar(dadosComandas.formaPagamento, dadosComandas.taxaServico, dadosComandas.taxaEntrega, descontoMonetario);
              carregarComanda();
            }}
            closeActionSimple={() => setShowModalDesconto(false)}
          />
        </IonModal>

        {/* Modal: Alterar Produtos */}
        <IonModal className="fullscreen-modal" isOpen={showAlterarProdutos} onDidDismiss={() => setShowAlterarProdutos(false)}>
          <AlterarProdutosModal
            projetoid={projetoid.replaceAll(/#/g, '%23')}
            listaInicial={listaItemProdutos}
            dadosComandas={dadosComandas}
            dadosEmpresa={dadosEmpresa}
            onClose={() => setShowAlterarProdutos(false)}
            onConfirm={(attrs: any) => {
              setDadosComandas(attrs);
              const prods = attrs.produtos || [];
              setListaItemProdutos(prods);
              const total = prods.reduce((acc: number, item: any) => {
                return acc + (parseFloat(String(item.subtotal).replace(/\./g, '').replace(',', '.')) || 0);
              }, 0);
              setValorTotalProdutos(total.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
              setShowAlterarProdutos(false);
              setTextToast('Produtos atualizados!');
              setShowToast(true);
            }}
          />
        </IonModal>

        {/* Modal: Alterar Pagamento */}
        <IonModal className="fullscreen-modal" isOpen={showAlterarPagamento} onDidDismiss={() => setShowAlterarPagamento(false)}>
          <AlterarPagamentoModal
            projetoid={projetoid.replaceAll(/#/g, '%23')}
            dadosComandas={dadosComandas}
            onClose={() => setShowAlterarPagamento(false)}
            onConfirm={(novaComanda: any) => {
              if (novaComanda) setDadosComandas(novaComanda);
              setShowAlterarPagamento(false);
              setTextToast('Pagamento atualizado!');
              setShowToast(true);
            }}
          />
        </IonModal>

        <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
      </IonContent>
    </IonPage>
  );
};

export default ComandasDetalhes;
